// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentChannelsPage-CardPageHeader_cls1__6ekrz","cls2":"PaymentChannelsPage-CardPageHeader_cls2__qSsvN PaymentChannelsPage-CardPageHeader_cls1__6ekrz"};